/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface AdminOutputDto { 
    cdAdmin?: number;
    dsName?: string;
    dsEmail?: string;
    dsUsername?: string;
    dsRememberToken?: string;
    dsLogo?: string;
    dsFb?: string;
    dsInsta?: string;
    dsTwitter?: string;
    dsYoutube?: string;
    dsSmsApi?: string;
    dsCurrency?: string;
    dsStoreType?: string;
    dsApiMeli?: string;
    dsMeliPublicKey?: string;
}